import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  width: calc((100% - 16px) / 3);
  margin-bottom: 16px;
  * {
    text-decoration: none;
    color: #000;
  }
  .thumb {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    box-sizing: border-box;
    &:hover {
      border-color: rgba(0, 0, 0, 0.2);
    }
  }
  .name {
    letter-spacing: -1px;
    font-size: 10.5px;
    font-weight: 500;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  &:not(:nth-child(3n)) {
    margin-right: 8px;
  }
`;

const Product = ({ product }) => {
  return (
    <Wrapper>
      <a href={product.url} target="_blank">
        <img src={product.thumbnail} className="thumb" alt={product.name} />
        <div className="name">{product.name}</div>
      </a>
    </Wrapper>
  );
};

export default Product;
